import React from "react";
import { Link } from "react-router-dom";
import { firePixels } from "../../utils/pixelFiring";

export const ItemsPlanes = ({ link, name, amount, img, id, pixelTags }) => {
    return (
        <>
            {
                (link,
                name
                // amount,
                // img
                ? (
                    <Link to={link} className="collapseDiv--item" onClick={() => firePixels(pixelTags, 'nav_click')}>
                        <img src={`/storage/modelos/${id}/${img}`} />
                        <div>
                            <h1>{name}</h1>
                            <div className="amount">
                                <h2 className="cuota-desde">Cuota desde</h2>
                                <h2>${amount}</h2>
                            </div>
                        </div>
                    </Link>
                ) : (
                    <p>Cargando...A</p>
                ))
            }
        </>
    );
};
